import Tr from 'translations/Translations';

export const ContractorConsorciumTypesOnePosition = {
    NONE: "NONE",
    ALL:"ALL"
}
export const ContractorConsorciumTypes = {
    NONE: "NONE",
    ALL:"ALL",
    POSITION:"POSITION"
}

const _TR_PREFIX = 'contractor_consorcium_type_';
export const ContractorConsorciumTypesLabel = (type) => (Tr(_TR_PREFIX + type.toLowerCase()));
